// Framework
import { call, put, select } from 'redux-saga/effects';
import { getCompany, getMarkers } from 'api/map';
import { getAuth } from 'actions/auth/login';
import { getLocale } from 'actions/language/selectors';
import { pushFormattedError } from 'helpers/formValidationHelper/formValidationMessage';
import { setUsers } from './mapActions';

// Selectors

/*** Fetch Users ***/
// Worker
export function* initializeAsyncMapWorker() {
  try {
    const locale = yield select(getLocale);
    const auth = yield select(getAuth);
    const {
      company: { id: companyId }
    } = yield call(getCompany, locale, auth);
    const { users } = yield call(getMarkers, locale, auth, companyId);
    yield put(setUsers(users));
  } catch (err) {
    yield pushFormattedError(err);
  }
}



// WEBPACK FOOTER //
// ./src/actions/travelSecurity/map/mapSagas.js